// SyllySync brand colors (matching Flutter app constants.dart)
export const COLORS = {
  primary: '#2AB3C0',      // Teal
  accent: '#FF914D',       // Orange

  // Neutral colors
  white: '#FFFFFF',
  black: '#000000',
  gray: {
    50: '#f9fafb',
    100: '#f3f4f6',
    200: '#e5e7eb',
    300: '#d1d5db',
    400: '#9ca3af',
    500: '#6b7280',
    600: '#4b5563',
    700: '#374151',
    800: '#1f2937',
    900: '#111827',
  },

  // Status colors
  success: '#10b981',
  error: '#ef4444',
  warning: '#f59e0b',
  info: '#3b82f6',
  negative: '#ef4444',
};

// Brand assets
export const ASSETS = {
  textLogo: '/textLogo.png',
};
